<template>
  <div id="applicationStore" v-click-outside="Hide">
    <div class="cursorPointer" @click="isShowApplicationStore = !isShowApplicationStore">
      <img v-if="!isShowApplicationStore" src="@/assets/img/applicationStore/ic_bento.png" />
      <img v-if="isShowApplicationStore" src="@/assets/img/applicationStore/ic_bento_active.png" />
    </div>
    <div v-show="isShowApplicationStore" class="applicationStore-menu-list">
      <p class="text-center pt-3 pb-1">{{ $t("Text_GoingTo") }}</p>
      <hr />
      <div class="row">
        <div class="col-4 appItem" v-if="oldPeakEnabled" @click="isCanUseOldPeak && RedirectToPeak()">
          <div class="lockOrCanNotAccess" v-if="!isCanUseOldPeak">
            <i class="fas fa-lock"></i>
            <p>{{ $t("Limited_User_rights") }}</p>
          </div>
          <img :src="peakFileServer.UrlCombine('peakengine/Content/Image/ApplicationStore/Logo_PEAK.png')" />
          <p><i class="fas fa-lock mr-1" v-if="!getMerchant.roleApplication.peakEngine"></i>Old PEAK</p>
        </div>
        <div class="col-4 appItem" @click="RedirectToNewPeak()">
          <img :src="peakFileServer.UrlCombine('peakengine/Content/Image/ApplicationStore/Logo_NewPEAK.png')" />
          <p>PEAK</p>
        </div>
        <div class="col-4 appItem" @click="isCanUsePeakPayroll && RedirectToPeakPayroll()">
          <div class="lockOrCanNotAccess" v-if="!getMerchant.roleApplication.peakPayroll">
            <i class="fas fa-lock"></i>
            <p>{{ $t("Limited_User_rights") }}</p>
          </div>
          <img :src="peakFileServer.UrlCombine('peakengine/Content/Image/ApplicationStore/Logo_Payroll.png')" />
          <p><i class="fas fa-lock mr-1" v-if="!getMerchant.roleApplication.peakPayroll"></i>PEAK Payroll</p>
          <h4 class="freeTrial" v-if="isFreeTrialPackage">{{ $t("Free_Trial") }}</h4>
        </div>
        <div class="col-4 appItem" @click="isCanUsePeakBoard && RedirectToPeakBoard()">
          <div class="lockOrCanNotAccess" v-if="!getMerchant.roleApplication.peakBoard">
            <i class="fas fa-lock"></i>
            <p>{{ $t("Limited_User_rights") }}</p>
          </div>
          <img :src="peakFileServer.UrlCombine('peakengine/Content/Image/ApplicationStore/Logo_Board.png')" />
          <p><i class="fas fa-lock mr-1" v-if="!getMerchant.roleApplication.peakBoard"></i>PEAK Board</p>
          <h4 class="freeTrial" v-if="isFreeTrialPackage">{{ $t("Free_Trial") }}</h4>
        </div>
        <div class="col-4 appItem" @click="isCanUsePeakAsset && RedirectToPeakAsset()">
          <div class="lockOrCanNotAccess" v-if="!getMerchant.roleApplication.peakAsset">
            <i class="fas fa-lock"></i>
            <p>{{ $t("Limited_User_rights") }}</p>
          </div>
          <img :src="peakFileServer.UrlCombine('peakengine/Content/Image/ApplicationStore/Logo_ASSET.png')" />
          <p><i class="fas fa-lock mr-1" v-if="!getMerchant.roleApplication.peakAsset"></i>PEAK Asset</p>
          <h4 class="freeTrial" v-if="isFreeTrialPackage">{{ $t("Free_Trial") }}</h4>
        </div>
        <div class="col-4 appItem" @click="RedirectToPeakTax()">
          <img :src="peakFileServer.UrlCombine('peakengine/Content/Image/ApplicationStore/Logo_TAX.png')" />
          <p>PEAK Tax</p>
          <h4 class="freeTrial" v-if="isFreeTrialPackage">{{ $t("Free_Trial") }}</h4>
        </div>
        <div class="col-4 appItem" @click="isCanUsePeakConnect && DoShowModalLinePEAKConnect()">
          <img :src="peakFileServer.UrlCombine('peakengine/Content/Image/ApplicationStore/Logo_PEAKConnect.png')" />
          <p>LINE @PEAKConnect</p>
        </div>
        <div class="col-4 appItem newBadge" :data-text="$t('New_Menu')" @click="DoShowModalPEAKMobile()">
          <img
            :src="peakFileServer.UrlCombine('peakengine/Content/Image/ApplicationStore/Logo_PeakMobile.png')"
            alt="PEAK Mobile Logo"
          />
          <p>PEAK Mobile</p>
        </div>
      </div>
    </div>
    <ModalLinePEAKConnect v-if="showModalLinePEAKConnect" :showModal.sync="showModalLinePEAKConnect" />
    <ModalPEAKMobile v-if="showModalPEAKMobile" :showModal.sync="showModalPEAKMobile" />
  </div>
</template>

<script lang="ts">
import ModalPEAKMobile from "@/components/modal/modalPEAKMobile/ModalPEAKMobile.vue";
import { ApplipcationStoreType, Package, TwoFactorAuthenticationType } from "@/enums/enums";
import { CheckIsDevelop } from "@/helper/shareHelper";
import {
  CheckMerchantAFPPackage,
  CheckMerchantPackage,
  GetMerchantPackageRight,
  MerchantId,
} from "@/helper/userHelper";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ModalLinePEAKConnect from "./ModalLinePEAKConnect.vue";

const StoreLogIn = namespace("LogIn");

@Component({ components: { ModalLinePEAKConnect, ModalPEAKMobile } })
export default class ApplicationStore extends Vue {
  private isShowApplicationStore = false;
  private PeakPeakengineURL = process.env.VUE_APP_PeakEngine;
  private PeakAccountURL = process.env.VUE_APP_PeakAccount;
  private showModalLinePEAKConnect = false;
  private peakFileServer = process.env.VUE_APP_PeakFileServer?.toString() ?? "";
  private isDevelop = CheckIsDevelop();
  private showDueDatePeakBoard = false;
  private isMerchantPackageAFP = CheckMerchantAFPPackage();
  private isFreeTrialPackage = CheckMerchantPackage([Package.Trial]);
  private isPremiumPackage = CheckMerchantPackage([Package.Premium]);
  private merchantPackageRight = GetMerchantPackageRight();
  private showModalPEAKMobile = false;

  @StoreLogIn.Getter
  public getUserModel!: any;

  get isCanUsePeakBoard() {
    return this.$can("access", "PeakBoard");
  }

  get isCanUsePeakAsset() {
    return this.$can("access", "PeakAsset");
  }

  get isCanUsePeakPayroll() {
    return this.$can("access", "PeakPayroll");
  }

  get isEnable2Fa() {
    return (
      this.getUserModel.twoFactorAuthenticationTypeId === TwoFactorAuthenticationType.Email ||
      this.getUserModel.twoFactorAuthenticationTypeId === TwoFactorAuthenticationType.Authenticator
    );
  }

  get oldPeakEnabled() {
    return this.getMerchant?.isActiveOldPEAK === true;
  }

  get isCanUseOldPeak() {
    return (
      !this.isMerchantPackageAFP &&
      this.$can("access", "OldPeak") &&
      !this.isPremiumPackage &&
      !this.isEnable2Fa &&
      this.oldPeakEnabled
    );
  }
  get isCanUsePeakConnect() {
    return !this.isMerchantPackageAFP;
  }
  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel;

  @StoreLogIn.Action
  private DoRedirectByApplicationStore!: (applipcationStoreType: ApplipcationStoreType) => void;

  public Hide() {
    this.isShowApplicationStore = false;
  }
  public RedirectToPeak() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.Peak);
  }
  public RedirectToNewPeak() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.NewPeak);
  }
  public RedirectToPeakPayroll() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.Payroll);
  }
  public RedirectToPeakBoard() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.Board);
  }
  public DoShowModalLinePEAKConnect() {
    this.Hide();
    this.showModalLinePEAKConnect = true;
  }
  public RedirectToPeakAsset() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.Asset);
  }
  public RedirectToUpgrade() {
    window.open(`${process.env.VUE_APP_PeakAccount}setting/billing?emi=${MerchantId().PeakEncryption()}`);
  }
  public RedirectToPeakTax() {
    this.$router.push({
      name: "home",
      query: { emi: MerchantId().PeakEncryption() },
    });
    this.Hide();
  }
  public DoShowModalPEAKMobile() {
    this.Hide();
    this.showModalPEAKMobile = true;
  }
}
</script>

<style lang="scss" scoped>
@include textFreeTrial;
#applicationStore {
  position: relative;
  margin-top: -10px;
  margin-left: 7px;
  .applicationStore-menu-list {
    position: absolute;
    top: 35px;
    right: -13px;
    background: white;
    z-index: 999;
    width: 400px;
    border-radius: 6px;
    padding: 10px;
    &::before {
      content: " ";
      position: absolute;
      top: -8px;
      right: 15px;
      width: 8px;
      border-bottom: 8px solid white;
      border-right: 8px solid #f5deb300;
      border-left: 8px solid #a52a2a00;
    }
    hr {
      margin: 5px 0px;
    }
    @include shadowboxLv2;
    .row {
      margin: 0px;
      padding: 0px 0px;
    }
    .appItem {
      margin-bottom: 10px;
      cursor: pointer;
      padding: 10px;
      width: 80px;
      text-align: center;
      border-radius: 4px;
      img {
        margin-bottom: 5px;
        width: 60px;
      }
      &:hover {
        background: #cce2ff;
      }
      .lockOrCanNotAccess {
        position: absolute;
        background: rgba(255, 255, 255, 0.7);
        height: 100%;
        width: 100%;
        z-index: 999;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        border-radius: 4px;
        display: flex;
        gap: 10px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 16px;
        i {
          font-size: 24px;
        }
        i,
        p {
          display: none;
          color: white !important;
          max-width: 80px;
        }
        &:hover {
          background: rgba(26, 26, 26, 0.85);
          i,
          p {
            display: unset;
          }
        }
      }
    }
  }
  .tooltip-peakDashboard {
    position: absolute;
    background: white;
    padding: 10px;
    border-radius: 6px;
    margin-top: -1px;
    z-index: 99;
    right: 5px;
    width: 290px;
    @include shadowboxLv2;
  }
  .pro-plus {
    background: linear-gradient(to right, #6c6df2 0%, #44e5e6 100%);
    color: #fff;
    border-radius: 20px;
    padding: 0px 2px;
    margin: 0px 4px;
  }
}
.newBadge {
  position: relative;
  &::before {
    position: absolute;
    content: attr(data-text);
    top: 0;
    left: calc(50% - 4px);
    background-color: $bgBlue;
    color: $blue_default;
    font-weight: 700;
    font-size: 14px;
    padding: 2px 4px 0 4px;
    border-radius: 4px;
    box-shadow:
      0px 2px 4px -1px #0000000f,
      0px 4px 6px -1px #0000001a;
    min-width: 34px;
  }
}
</style>
